export const validateApartmentCount = (count: number, min: number, max: number) => {
  if (count > max) {
    return max;
  } else if (count < min) {
    return min;
  }
  return count;
};
